import { IconType } from "react-icons";
import { BsPersonWorkspace, BsQuestionCircle } from "react-icons/bs";
import { FiPenTool } from "react-icons/fi";
import { GrProjects, GrServices } from "react-icons/gr";
import { IoMdHome, IoMdHelpCircleOutline } from "react-icons/io";
import { MdContactMail, MdGroups } from "react-icons/md";
import { SiMinutemailer } from "react-icons/si";
import { FaCode } from "react-icons/fa6";

/** Stable IDs for top-level nav entries — used to look up labels in the dict. */
export type NavLinkId =
  | "home"
  | "projects"
  | "services"
  | "company"
  | "blogs"
  | "contactUs"
  | "designs"
  | "about"
  | "career"
  | "faqs";

/** Stable IDs for submenu items. */
export type SubNavItemId =
  | "developments"
  | "designs"
  | "about"
  | "career"
  | "faq"
  | "contactUs";

export interface SubNavItem {
  id: SubNavItemId;
  href: string;
  icon: IconType;
}

export interface NavLink {
  id: NavLinkId;
  type: "link" | "group";
  href: string;
  Icon: IconType;
  iconSize: number;
  showInAllScreen?: boolean;
  className: string;
  classNameForIcon: string;
  disabled?: boolean;
  onlyMobile?: boolean;
  subItems?: SubNavItem[];
}

export const links: NavLink[] = [
  {
    id: "home",
    type: "link",
    href: "/",
    Icon: IoMdHome,
    iconSize: 16,
    showInAllScreen: true,
    className: "",
    classNameForIcon: "text-lg",
  },
  {
    id: "projects",
    type: "group",
    href: "/projects",
    Icon: GrProjects,
    iconSize: 16,
    showInAllScreen: true,
    className: "",
    classNameForIcon: "text-sm",
    subItems: [
      { id: "developments", href: "/projects", icon: FaCode },
      { id: "designs", href: "/designs", icon: FiPenTool },
    ],
  },
  {
    id: "services",
    type: "link",
    href: "/services",
    Icon: GrServices,
    iconSize: 16,
    showInAllScreen: true,
    className: "",
    classNameForIcon: "",
  },
  {
    id: "company",
    type: "group",
    href: "/about-us",
    Icon: MdGroups,
    iconSize: 16,
    showInAllScreen: true,
    className: "",
    classNameForIcon: "text-lg",
    subItems: [
      { id: "about", href: "/about-us", icon: MdGroups },
      { id: "career", href: "/careers", icon: BsPersonWorkspace },
      { id: "faq", href: "/faq", icon: BsQuestionCircle },
      { id: "contactUs", href: "/contact-us", icon: MdContactMail },
    ],
  },
  {
    id: "blogs",
    type: "link",
    href: "/blogs",
    Icon: BsPersonWorkspace,
    iconSize: 16,
    disabled: false,
    className: "",
    classNameForIcon: "",
  },
  {
    id: "contactUs",
    type: "link",
    href: "/contact-us",
    Icon: SiMinutemailer,
    iconSize: 16,
    onlyMobile: true,
    disabled: false,
    className: "",
    classNameForIcon: "",
  },
].filter((link) => !link.disabled) as NavLink[];

// Mobile links (flat 1D array, no nesting):
// home, projects, designs, services, about, career, blogs, faqs, and other links (contact)
export const mobileLinks: NavLink[] = [
  {
    id: "home",
    type: "link",
    href: "/",
    Icon: IoMdHome,
    iconSize: 16,
    showInAllScreen: true,
    className: "",
    classNameForIcon: "text-lg",
  },
  {
    id: "projects",
    type: "link",
    href: "/projects",
    Icon: GrProjects,
    iconSize: 16,
    className: "",
    classNameForIcon: "text-sm",
  },
  {
    id: "designs",
    type: "link",
    href: "/designs",
    Icon: FiPenTool,
    iconSize: 16,
    className: "",
    classNameForIcon: "",
  },
  {
    id: "services",
    type: "link",
    href: "/services",
    Icon: GrServices,
    iconSize: 16,
    className: "",
    classNameForIcon: "",
  },
  {
    id: "about",
    type: "link",
    href: "/about-us",
    Icon: MdGroups,
    iconSize: 16,
    className: "",
    classNameForIcon: "text-lg",
  },
  {
    id: "career",
    type: "link",
    href: "/careers",
    Icon: BsPersonWorkspace,
    iconSize: 16,
    className: "",
    classNameForIcon: "",
  },
  {
    id: "blogs",
    type: "link",
    href: "/blogs",
    Icon: BsPersonWorkspace,
    iconSize: 16,
    className: "",
    classNameForIcon: "",
  },
  {
    id: "faqs",
    type: "link",
    href: "/faq",
    Icon: IoMdHelpCircleOutline,
    iconSize: 16,
    className: "",
    classNameForIcon: "",
  },
  {
    id: "contactUs",
    type: "link",
    href: "/contact-us",
    Icon: SiMinutemailer,
    iconSize: 16,
    className: "",
    classNameForIcon: "",
  },
];
